export default __webpack_public_path__ + "static/media/ones_zeros.08fa51a4.jpg";